﻿export enum ePerm {
    viewUsers = "viewUsers",
    modifyUsers = "modifyUsers",
    modifyMedia = "modifyMedia",
    viewProducts = "viewProducts",
    modifyProducts = "modifyProducts",
    viewCustomers = "viewCustomers",
    modifyCustomers = "modifyCustomers",
    viewComments = "viewComments",
    addComments = "addComments",
    modifyAllComments = "modifyAllComments",
    viewAttachments = "viewAttachments",
    addAttachments = "addAttachments",
    modifyAllAttachments = "modifyAllAttachments",
    modifyCurrencies = "modifyCurrencies",
    modifyScenes = "modifyScenes",
    setQuoteDiscount = "setQuoteDiscount",
    setQuoteCustomer = "setQuoteCustomer",
    setQuoteShipping = "setQuoteShipping",
    setQuoteCurrency = "setQuoteCurrency",
    viewQuoteDiscount = "viewQuoteDiscount",
    viewQuoteCustomer = "viewQuoteCustomer",
    viewQuoteShipping = "viewQuoteShipping",
    viewQuoteHeader = "viewQuoteHeader",
    viewQuoteCurrency = "viewQuoteCurrency",
    viewPrices = "viewPrices",
    viewCost = "viewCost",
    loginToOutputBuilder = "loginToOutputBuilder",
    setQuoteProductDescription = "setQuoteProductDescription",
    viewQuoteOwner = "viewQuoteOwner",
    setQuoteOwner = "setQuoteOwner",
}
export enum eNotificationType {
    generic = "generic",
    newUser = "newUser",
    passwordReset = "passwordReset",
    pendingApproval = "pendingApproval",
    quoteApproved = "quoteApproved",
    quoteRejected = "quoteRejected",
    quote = "quote",
    errorLog = "errorLog",
}
export enum eNotificationSetting {
    none = "none",
    companyDefault = "companyDefault",
    notify = "notify",
    email = "email",
    notifyAndEmail = "notifyAndEmail",
}
export enum eEnvironment {
    prod = "prod",
    test = "test",
    dev = "dev",
}
export enum eWorkflowAction {
    custom = "custom",
    save = "save",
    deleter = "deleter",
    submit = "submit",
    unsubmit = "unsubmit",
    approve = "approve",
    reject = "reject",
    entryFail = "entryFail",
    completeBuild = "completeBuild",
    failBuild = "failBuild",
    modifyProducts = "modifyProducts",
    modifyDiscount = "modifyDiscount",
    modifyName = "modifyName",
    modifyCustomer = "modifyCustomer",
    modifyAttachments = "modifyAttachments",
    addAttachments = "addAttachments",
    modifyQuoteHeader = "modifyQuoteHeader",
    modifyCurrency = "modifyCurrency",
    reorderProducts = "reorderProducts",
    modifyQuoteProductDescription = "modifyQuoteProductDescription",
    modifyShipping = "modifyShipping",
    buildQuoteProduct = "buildQuoteProduct",
    assignQuote = "assignQuote",
}
export enum eViewPermission {
    viewQuote = "viewQuote",
    viewCost = "viewCost",
    viewPricing = "viewPricing",
    viewDiscount = "viewDiscount",
    viewCustomer = "viewCustomer",
    viewOutput = "viewOutput",
    viewQuoteHeader = "viewQuoteHeader",
    viewCurrency = "viewCurrency",
    viewShipping = "viewShipping",
    viewQuoteProductDetails = "viewQuoteProductDetails",
    submitQuote = "submitQuote",
    viewQuoteOwner = "viewQuoteOwner",
}
export enum eOutputType {
    none = "none",
    word = "word",
    excel = "excel",
    image = "image",
    solidworks = "solidworks",
    inventor = "inventor",
    creo = "creo",
    creo3 = "creo3",
    cadDrawing = "cadDrawing",
    bom = "bom",
    sceneRender = "sceneRender",
    sceneModel = "sceneModel",
    pdf = "pdf",
    salesforce = "salesforce",
    autoCad = "autoCad",
    zip = "zip",
    svg = "svg",
    text = "text",
}
export enum eOutputFieldType {
    wordText = "wordText",
    wordContainer = "wordContainer",
    wordImage = "wordImage",
    wordList = "wordList",
    excelSheet = "excelSheet",
    excelCell = "excelCell",
    excelImage = "excelImage",
    excelTable = "excelTable",
    excelChart = "excelChart",
    cadReplaceComponent = "cadReplaceComponent",
    cadAngleMate = "cadAngleMate",
    cadCoincidentMate = "cadCoincidentMate",
    cadCoordinateSystemMate = "cadCoordinateSystemMate",
    cadDistanceMate = "cadDistanceMate",
    cadPositionConstraint = "cadPositionConstraint",
    cadDimension = "cadDimension",
    cadFeature = "cadFeature",
    cadLibFeature = "cadLibFeature",
    cadCustomProperty = "cadCustomProperty",
    cadComponent = "cadComponent",
    cadDrawingView = "cadDrawingView",
    cadDrawingSheet = "cadDrawingSheet",
    cadDrawingAnnotation = "cadDrawingAnnotation",
    cadDynamicDrawingDimension = "cadDynamicDrawingDimension",
    cadDynamicDrawingAnnotation = "cadDynamicDrawingAnnotation",
    cadDynamicComponent = "cadDynamicComponent",
    cadNestedComponent = "cadNestedComponent",
    cadScaleFeature = "cadScaleFeature",
    cadAnnotation = "cadAnnotation",
    cadText = "cadText",
    cadParameter = "cadParameter",
    cadRepresentation = "cadRepresentation",
    cadPoint = "cadPoint",
    cadLayer = "cadLayer",
    bomMapping = "bomMapping",
    salesForceObject = "salesForceObject",
    cadDrawingDimension = "cadDrawingDimension",
    pdfSection = "pdfSection",
    cadLibReference = "cadLibReference",
    cadLibDimension = "cadLibDimension",
    cadBlock = "cadBlock",
    cadBlockArray = "cadBlockArray",
    zipSection = "zipSection",
}
export enum eExportType {
    _custom = "_custom",
    pdf = "pdf",
    bmp = "bmp",
    doc = "doc",
    docm = "docm",
    dot = "dot",
    dotm = "dotm",
    dotx = "dotx",
    emf = "emf",
    epub = "epub",
    html = "html",
    jpg = "jpg",
    gif = "gif",
    tiff = "tiff",
    dwf = "dwf",
    edrw = "edrw",
    png = "png",
    odt = "odt",
    rtf = "rtf",
    tif = "tif",
    xaml = "xaml",
    xps = "xps",
    ods = "ods",
    svg = "svg",
    txt = "txt",
    easm = "easm",
    prt = "prt",
    g = "g",
    dwg = "dwg",
    dxf = "dxf",
    glb = "glb",
    fbx = "fbx",
    sldprt = "sldprt",
    sldasm = "sldasm",
    slddrw = "slddrw",
    sldlfp = "sldlfp",
    x_t = "x_t",
    x_b = "x_b",
    igs = "igs",
    stl = "stl",
    wrl = "wrl",
    u3d = "u3d",
    psd = "psd",
    ai = "ai",
    cgr = "cgr",
    asm = "asm",
    hcg = "hcg",
    hsf = "hsf",
    sat = "sat",
    stp = "stp",
    step = "step",
    vda = "vda",
    neu = "neu",
    iv = "iv",
    slp = "slp",
    eps = "eps",
    catproduct = "catproduct",
    jt = "jt",
    zgl = "zgl",
    xgl = "xgl",
    csv = "csv",
    xml = "xml",
}
export enum eFileSource {
    generated = "generated",
    uploaded = "uploaded",
    media = "media",
    fileUploadField = "fileUploadField",
}
export enum eFileStatus {
    none = "none",
    generating = "generating",
    complete = "complete",
    failed = "failed",
}
export enum eLogType {
    info = "info",
    error = "error",
    warning = "warning",
}
export enum eLogSource {
    productRule = "productRule",
    workflowRule = "workflowRule",
    quoteHeaderRule = "quoteHeaderRule",
    quoteAction = "quoteAction",
    output = "output",
    outputRule = "outputRule",
    outputDriver = "outputDriver",
    safeFunction = "safeFunction",
    restHelper = "restHelper",
    workerRole = "workerRole",
    sceneImporterWatcher = "sceneImporterWatcher",
    sceneExporterWatcher = "sceneExporterWatcher",
    notificationQueueWatcher = "notificationQueueWatcher",
    configuratorPricingRule = "configuratorPricingRule",
    configuratorSubmitRule = "configuratorSubmitRule",
    configuratorNamingRule = "configuratorNamingRule",
    configuratorLoadedRule = "configuratorLoadedRule",
    configuratorValueRule = "configuratorValueRule",
    configuratorValidationRule = "configuratorValidationRule",
    configuratorMethodOfManufactureRule = "configuratorMethodOfManufactureRule",
    table = "table",
    kineticDocumentRules = "kineticDocumentRules",
}
export enum eFieldType {
    text = "text",
    number = "number",
    boolean = "boolean",
    color = "color",
    date = "date",
    upload = "upload",
    textArray = "textArray",
    numberArray = "numberArray",
    colorArray = "colorArray",
}
export enum eFieldControl {
    none = "none",
    textbox = "textbox",
    multilineTextbox = "multilineTextbox",
    label = "label",
    numberbox = "numberbox",
    checkbox = "checkbox",
    toggle = "toggle",
    select = "select",
    colorSelect = "colorSelect",
    button = "button",
    upload = "upload",
    slider = "slider",
    imageSelect = "imageSelect",
    colorPicker = "colorPicker",
    swatchSelect = "swatchSelect",
    autoComplete = "autoComplete",
    media = "media",
    html = "html",
    datePicker = "datePicker",
    multiSelect = "multiSelect",
    colorMultiSelect = "colorMultiSelect",
    imageMultiSelect = "imageMultiSelect",
    radio = "radio",
    mediaPicker = "mediaPicker",
}
export enum eSort {
    none = "none",
    ascending = "ascending",
    descending = "descending",
}
export enum eProductSortBy {
    relevance = "relevance",
    priceLowToHigh = "priceLowToHigh",
    priceHighToLow = "priceHighToLow",
    popularity = "popularity",
    nameAtoZ = "nameAtoZ",
}
export enum eFormatType {
    none = "none",
    number = "number",
    currency = "currency",
    percentage = "percentage",
}
export enum eRuleType {
    value = "value",
    visibility = "visibility",
    validation = "validation",
    pricing = "pricing",
    message = "message",
    loaded = "loaded",
    submit = "submit",
    pageChanged = "pageChanged",
    tabChanged = "tabChanged",
    expanderChanged = "expanderChanged",
    output = "output",
    action = "action",
    function = "function",
    global = "global",
    globalEvent = "globalEvent",
    safeFunction = "safeFunction",
    naming = "naming",
    field = "field",
    button = "button",
    svgViewer = "svgViewer",
    html = "html",
    dragStart = "dragStart",
    dragMove = "dragMove",
    dragEnd = "dragEnd",
    optionFilter = "optionFilter",
    nested = "nested",
    resize = "resize",
    nestedSetSelected = "nestedSetSelected",
    keyboard = "keyboard",
    manufacture = "manufacture",
    bistrackManufacture = "bistrackManufacture",
    kineticDocumentRules = "kineticDocumentRules",
    layout = "layout",
    configuratorAdded = "configuratorAdded",
    configuratorRemoved = "configuratorRemoved",
    configuratorCopied = "configuratorCopied",
    product = "product",
    workflow = "workflow",
    beforeBuild = "beforeBuild",
    globalDefinition = "globalDefinition",
    globalFunction = "globalFunction",
    quote = "quote",
    scene = "scene",
    sceneLoaded = "sceneLoaded",
    xrEnter = "xrEnter",
    xrExit = "xrExit",
}
export enum eClusterEnv {
    prod = "prod",
    staging = "staging",
    debug = "debug",
    next = "next",
    dev = "dev",
}
export enum eConfiguratorLayout {
    standard = "standard",
    immersive = "immersive",
}
export enum eConfiguratorTabStyle {
    cards = "cards",
    tree = "tree",
}
export enum eDeploymentStatus {
    inProgress = "inProgress",
    success = "success",
    failed = "failed",
}
export enum eDifference {
    none = "none",
    changed = "changed",
    added = "added",
    removed = "removed",
}
export enum eViewerMode {
    none = "none",
    media = "media",
    scene = "scene",
}
export enum ePosition {
    left = "left",
    right = "right",
}
export enum eTabPosition {
    left = "left",
    right = "right",
    top = "top",
    bottom = "bottom",
}
export enum eColumnType {
    text = "text",
    number = "number",
    boolean = "boolean",
    color = "color",
    date = "date",
    media = "media",
    translated = "translated",
}
export enum eSelectSource {
    simple = "simple",
    optionFilter = "optionFilter",
}
export enum eAutoCompleteSource {
    table = "table",
    database = "database",
}
export enum eOptionFilterSource {
    table = "table",
    database = "database",
    query = "query",
    safeFunction = "safeFunction",
    optionFilter = "optionFilter",
}
export enum eDynamicSource {
    media = "media",
    template = "template",
    output = "output",
    nested = "nested",
    nestedExport = "nestedExport",
    exprt = "exprt",
    url = "url",
    tag = "tag",
    quoteOutput = "quoteOutput",
    fileUploadField = "fileUploadField",
}
export enum eQueryMode {
    none = "none",
    table = "table",
    database = "database",
    array = "array",
    optionFilter = "optionFilter",
    parentOptionFilter = "parentOptionFilter",
}
export enum eConfiguratorImageSource {
    none = "none",
    media = "media",
    scene = "scene",
}
export enum ePricingFillFromSource {
    none = "none",
    table = "table",
    database = "database",
}
export enum eSingleOptionBehavior {
    nothing = "nothing",
    disable = "disable",
    hide = "hide",
}
export enum eFilterSource {
    none = "none",
    enum = "enum",
    properties = "properties",
    users = "users",
    states = "states",
    configurators = "configurators",
    fields = "fields",
    customers = "customers",
    roles = "roles",
    productSorts = "productSorts",
    manufacturers = "manufacturers",
    attributes = "attributes",
    suggestContacts = "suggestContacts",
    suggestCustomers = "suggestCustomers",
    suggestQuotes = "suggestQuotes",
    suggestProducts = "suggestProducts",
    headerFields = "headerFields",
}
export enum eFilterType {
    property = "property",
    fieldValue = "fieldValue",
    sort = "sort",
    attribute = "attribute",
    headerValue = "headerValue",
}
export enum eFilterControl {
    none = "none",
    text = "text",
    select = "select",
    multiSelect = "multiSelect",
    dateRange = "dateRange",
    numberRange = "numberRange",
    suggest = "suggest",
    checkbox = "checkbox",
}
export enum eLogSetting {
    all = "all",
    minimal = "minimal",
}
export enum eHotspotSource {
    none = "none",
    text = "text",
    media = "media",
    element = "element",
}
export enum eHotspotAttach {
    topLeft = "topLeft",
    top = "top",
    topRight = "topRight",
    left = "left",
    center = "center",
    right = "right",
    bottomLeft = "bottomLeft",
    bottom = "bottom",
    bottomRight = "bottomRight",
}
export enum eLayerLineWeight {
    lnWtByLayer = "lnWtByLayer",
    lnWtByBlock = "lnWtByBlock",
    lnWtByLwDefault = "lnWtByLwDefault",
    lnWt000 = "lnWt000",
    lnWt005 = "lnWt005",
    lnWt009 = "lnWt009",
    lnWt013 = "lnWt013",
    lnWt015 = "lnWt015",
    lnWt018 = "lnWt018",
    lnWt020 = "lnWt020",
    lnWt025 = "lnWt025",
    lnWt030 = "lnWt030",
    lnWt035 = "lnWt035",
    lnWt040 = "lnWt040",
    lnWt050 = "lnWt050",
    lnWt053 = "lnWt053",
    lnWt060 = "lnWt060",
    lnWt070 = "lnWt070",
    lnWt080 = "lnWt080",
    lnWt090 = "lnWt090",
    lnWt100 = "lnWt100",
    lnWt106 = "lnWt106",
    lnWt120 = "lnWt120",
    lnWt140 = "lnWt140",
    lnWt158 = "lnWt158",
    lnWt200 = "lnWt200",
    lnWt211 = "lnWt211",
}
export enum eHotspotPosition {
    manual = "manual",
    target = "target",
}
export enum eAnimationEasing {
    linear = "linear",
    easeInQuad = "easeInQuad",
    easeOutQuad = "easeOutQuad",
    easeInOutQuad = "easeInOutQuad",
    easeInCubic = "easeInCubic",
    easeOutCubic = "easeOutCubic",
    easeInOutCubic = "easeInOutCubic",
    easeInQuart = "easeInQuart",
    easeOutQuart = "easeOutQuart",
    easeInOutQuart = "easeInOutQuart",
    easeInQuint = "easeInQuint",
    easeOutQuint = "easeOutQuint",
    easeInOutQuint = "easeInOutQuint",
    easeInSine = "easeInSine",
    easeOutSine = "easeOutSine",
    easeInOutSine = "easeInOutSine",
    easeInExpo = "easeInExpo",
    easeOutExpo = "easeOutExpo",
    easeInOutExpo = "easeInOutExpo",
    easeInCirc = "easeInCirc",
    easeOutCirc = "easeOutCirc",
    easeInOutCirc = "easeInOutCirc",
    easeInElastic = "easeInElastic",
    easeOutElastic = "easeOutElastic",
    easeInOutElastic = "easeInOutElastic",
    easeInBack = "easeInBack",
    easeOutBack = "easeOutBack",
    easeInOutBack = "easeInOutBack",
    easeInBounce = "easeInBounce",
    easeOutBounce = "easeOutBounce",
    easeInOutBounce = "easeInOutBounce",
}
export enum eQueueMessageType {
    builder = "builder",
    cleanDb = "cleanDb",
    completeBuildState = "completeBuildState",
    notification = "notification",
    render = "render",
    pullSfdcProducts = "pullSfdcProducts",
    upsertProductsToSfdc = "upsertProductsToSfdc",
    submitFromSfdcCpq = "submitFromSfdcCpq",
    deployment = "deployment",
    deploymentCompare = "deploymentCompare",
    completeQuoteProductBuild = "completeQuoteProductBuild",
    sceneImport = "sceneImport",
    sceneExport = "sceneExport",
    sceneConvert = "sceneConvert",
}
export enum eStateType {
    state = "state",
    approval = "approval",
    build = "build",
    unsubmitted = "unsubmitted",
}
export enum eDescriptorType {
    user = "user",
    role = "role",
    email = "email",
}
export enum eWorkflowBuildType {
    quoteOutput = "quoteOutput",
    configurator = "configurator",
}
export enum eWorkflowPermissionType {
    view = "view",
    viewOutput = "viewOutput",
}
export enum eAdminNotificationTarget {
    companyAdmins = "companyAdmins",
    allUsersExceptSelfRegistered = "allUsersExceptSelfRegistered",
}
export enum eConfiguratorEntityType {
    product = "product",
    quoteHeader = "quoteHeader",
}
export enum eHotspotShape {
    circle = "circle",
    circleWithText = "circleWithText",
    image = "image",
    mesh = "mesh",
    text = "text",
}
export enum eValidationType {
    error = "error",
    warning = "warning",
    info = "info",
}
export enum eIconStyle {
    none = "none",
    icon = "icon",
    media = "media",
}
export enum eOracleCpqOperation {
    createTransaction = "createTransaction",
    importFileAttachment = "importFileAttachment",
}
export enum eOptionLayout {
    wrap = "wrap",
    vertical = "vertical",
    scroll = "scroll",
}
export enum eButtonStyle {
    normal = "normal",
    link = "link",
    outline = "outline",
}
export enum eTableExternalSource {
    none = "none",
    database = "database",
}
export enum eSkin {
    classic = "classic",
    material = "material",
}
export enum eGridColumnWidth {
    auto = "auto",
    x1 = "x1",
    x2 = "x2",
    x3 = "x3",
    x4 = "x4",
    x5 = "x5",
    x6 = "x6",
    x7 = "x7",
    x8 = "x8",
    x9 = "x9",
    x10 = "x10",
    x11 = "x11",
    x12 = "x12",
}
export enum eRelativeSize {
    auto = "auto",
    x1 = "x1",
    x2 = "x2",
    x3 = "x3",
    x4 = "x4",
    x5 = "x5",
    x6 = "x6",
    x7 = "x7",
    x8 = "x8",
    x9 = "x9",
    x10 = "x10",
    x11 = "x11",
    x12 = "x12",
    custom = "custom",
}
export enum eVerticalAlignment {
    stretch = "stretch",
    top = "top",
    center = "center",
    bottom = "bottom",
}
export enum eHorizontalAlignment {
    left = "left",
    center = "center",
    right = "right",
}
export enum ePadding {
    none = "none",
    small = "small",
    medium = "medium",
    large = "large",
}
export enum eMaskType {
    none = "none",
    phone = "phone",
    zipCode = "zipCode",
}
export enum eValidationTiming {
    always = "always",
    onTouched = "onTouched",
}
export enum eTextStyle {
    normal = "normal",
    h1 = "h1",
    h2 = "h2",
    h3 = "h3",
    h4 = "h4",
    h5 = "h5",
    subtitle = "subtitle",
    emphasis = "emphasis",
    strong = "strong",
}
export enum eTextColor {
    normal = "normal",
    header = "header",
    primary = "primary",
    accent = "accent",
    error = "error",
    success = "success",
}
export enum eTextWeight {
    f100 = "f100",
    f200 = "f200",
    f300 = "f300",
    f400 = "f400",
    f500 = "f500",
    f600 = "f600",
    f700 = "f700",
    f800 = "f800",
    f900 = "f900",
}
export enum eDragMode {
    plane = "plane",
    free = "free",
    surface = "surface",
}
export enum eConnectionMode {
    none = "none",
    world = "world",
    screen = "screen",
}
export enum eToolbarPosition {
    hidden = "hidden",
    topLeft = "topLeft",
    topRight = "topRight",
    bottomLeft = "bottomLeft",
    bottomRight = "bottomRight",
}
export enum eContainerItemLayout {
    horizontal = "horizontal",
    vertical = "vertical",
    absolute = "absolute",
}
export enum eContainerChildAlignment {
    inherit = "inherit",
    stretch = "stretch",
    start = "start",
    center = "center",
    end = "end",
}
export enum eContainerItemAlignment {
    stretch = "stretch",
    start = "start",
    center = "center",
    end = "end",
}
export enum eContainerItemJustify {
    start = "start",
    center = "center",
    end = "end",
}
export enum eColorShade {
    default = "default",
    lighter1 = "lighter1",
    lighter2 = "lighter2",
    lighter3 = "lighter3",
    lighter4 = "lighter4",
    darker1 = "darker1",
    darker2 = "darker2",
    darker3 = "darker3",
    darker4 = "darker4",
}
export enum eBackgroundColor {
    background = "background",
    primary = "primary",
    accent = "accent",
    warning = "warning",
    success = "success",
    input = "input",
    header = "header",
}
export enum eElevation {
    none = "none",
    z1 = "z1",
    z2 = "z2",
    z3 = "z3",
    z4 = "z4",
    z5 = "z5",
    z6 = "z6",
    z7 = "z7",
    z8 = "z8",
}
export enum eSliderValueVisibility {
    visible = "visible",
    sliding = "sliding",
    hidden = "hidden",
}
export enum eOrientation {
    horizontal = "horizontal",
    vertical = "vertical",
}
export enum eTabSelectionStyle {
    line = "line",
    background = "background",
}
export enum eSelectionLineColor {
    accent = "accent",
    contrast = "contrast",
    primary = "primary",
    header = "header",
}
export enum eTabWidth {
    custom = "custom",
    fill = "fill",
    auto = "auto",
}
export enum eScroll {
    none = "none",
    auto = "auto",
    x = "x",
    y = "y",
}
export enum eAdminIndexOperation {
    updateQuotes = "updateQuotes",
}
export enum eAttributeType {
    text = "text",
    number = "number",
    boolean = "boolean",
    date = "date",
}
export enum eAttributeControl {
    select = "select",
    imageSelect = "imageSelect",
    multiSelect = "multiSelect",
    imageMultiSelect = "imageMultiSelect",
    checkbox = "checkbox",
}
export enum eNestedSetDisplay {
    container = "container",
    group = "group",
    tabControl = "tabControl",
    accordion = "accordion",
}
export enum eUserLicenseType {
    external = "external",
    internal = "internal",
    channel = "channel",
}
export enum eJobStatus {
    none = "none",
    waiting = "waiting",
    queued = "queued",
    working = "working",
    complete = "complete",
    failed = "failed",
}
export enum eJobType {
    build = "build",
    render = "render",
    notification = "notification",
    upsertProductsToSfdc = "upsertProductsToSfdc",
    pullSfdcProducts = "pullSfdcProducts",
    submitFromSfdcCpq = "submitFromSfdcCpq",
    completeBuildState = "completeBuildState",
    cleanDb = "cleanDb",
    deploymentCompare = "deploymentCompare",
    deployment = "deployment",
    sceneImport = "sceneImport",
    sceneExport = "sceneExport",
    sceneConvert = "sceneConvert",
    completeQuoteProductBuild = "completeQuoteProductBuild",
    configuratorExport = "configuratorExport",
    configuratorImport = "configuratorImport",
}
export enum eValidationSource {
    snap = "snap",
    configurator = "configurator",
    scene = "scene",
}
export enum eBuildStatus {
    none = "none",
    generating = "generating",
    complete = "complete",
    failed = "failed",
}
